/** The one state in which this technician can actually receive a push. */
export function isHealthyState(state) {
    return state === 'registered';
}
/**
 * Revoking only makes sense against a registration we know exists. Sending a
 * test only makes sense where push is live for the tenant — but it is offered
 * even with no device, because the platform records an unregistered publish as
 * `skipped_unregistered`, which is itself a useful diagnosis in the history.
 */
export function canRevoke(status) {
    return status.state === 'registered';
}
export function canSendTest(status) {
    return status.enabled;
}
